import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import CharacterCard from "@/components/feature/CharacterCard";
import { charactersList } from "@/mocks/characters";

export default function CharacterSpotlight() {
  const picks = [...charactersList].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 3);

  return (
    <section aria-labelledby="home-characters-heading" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <SectionHeading
        kicker="CHARACTERS"
        title="角色分析专题"
        description="不只聊人设，也聊角色在故事里做过的每一个选择。"
        actionLabel="浏览全部专题"
        actionTo="/characters"
      />
      <h2 id="home-characters-heading" className="sr-only">角色分析专题</h2>
      {picks.length === 0 ? (
        <p className="text-sm text-foreground-500">暂无相关内容</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {picks.map((item) => (
            <CharacterCard key={item.id} item={item} />
          ))}
        </div>
      )}

      <div className="mt-6 rounded-lg bg-secondary-50 border border-secondary-100 p-4 md:p-5 flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
        <div className="flex items-center gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-900 shrink-0">
            <i className="ri-quill-pen-line text-lg"></i>
          </span>
          <div>
            <p className="text-sm font-semibold text-foreground-900">专题仍在更新中</p>
            <p className="text-xs text-foreground-500 mt-0.5">每周新增 2-3 篇角色深度解析，欢迎持续关注。</p>
          </div>
        </div>
        <Link
          to="/characters"
          className="md:ml-auto inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          前往专题页
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}